import React from 'react';
import AntdTable, {TableProps } from "antd/lib/table";
import {withError} from '@fishx/tracker';

const SELECTION_ALL = AntdTable.SELECTION_ALL;
const SELECTION_INVERT = AntdTable.SELECTION_INVERT;
const SELECTION_NONE = AntdTable.SELECTION_NONE;
const Column = AntdTable.Column;
const ColumnGroup = AntdTable.ColumnGroup;
const Summary = AntdTable.Summary;

interface FCProps extends React.FC<TableProps<object>> {
  SELECTION_ALL: typeof SELECTION_ALL;
  SELECTION_INVERT: typeof SELECTION_INVERT;
  SELECTION_NONE: typeof SELECTION_NONE;
  Column: typeof Column;
  ColumnGroup: typeof ColumnGroup;
  Summary: typeof Summary;
}
export const Table: FCProps = (props) =>{
  return <AntdTable {...props}/>
}
Table.SELECTION_ALL = SELECTION_ALL;
Table.SELECTION_INVERT = SELECTION_INVERT;
Table.SELECTION_NONE = SELECTION_NONE;
Table.Column = Column;
Table.ColumnGroup = ColumnGroup;
Table.Summary = Summary;
Table.displayName = 'Table';
export default withError(Table);



// WEBPACK FOOTER //
// ./src/components/table/index.tsx